export const positionStatus = [
    "Regular full-time",
    "Regular part-time",
    "Temporary",
    "Seasonal",
    "At-will",
  ];